import { ProjectOperator } from "./ProjectOperator";
import {UserInfOperator} from "./UserInfOperator";
import {DataOperator} from "./DataOperator";
import {ServiceDriverOperator} from "./ServiceDriverOperator";
import {FinanceOperator} from "./FinanceOperator";

export const consoleApi = new class {
    public readonly user: UserInfOperator = new UserInfOperator();
    public readonly data: DataOperator = new DataOperator();
    public readonly driver: ServiceDriverOperator = new ServiceDriverOperator();
    public readonly project: ProjectOperator = new ProjectOperator();
    public readonly finance: FinanceOperator = new FinanceOperator();
};



// WEBPACK FOOTER //
// ./src/apiMiddleware/consoleApi.ts